import { StyleSheet } from 'aphrodite/no-important';
import { children, media, palette } from 'util/style-helpers';

interface IAgreementFormStyleProps {
  hasCustomOptions?: boolean;
}

export const style: any = (props: IAgreementFormStyleProps) => {
  return StyleSheet.create({
    overlay: {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      inset: 0,
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.65)',
      overflowY: 'auto',
      zIndex: 9999,
    },
    modal: {
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      overflowY: 'auto',
      padding: '25px',
      maxHeight: '100%',
      margin: 'auto 20px',
      borderRadius: 5,
      background: 'white',
      ':focus': {
        outline: 'none',
      },
      [media.tablet]: {
        padding: '40px 54px',
        margin: 'auto 52px',
      },
      [media.desktop]: {
        padding: '58px 68px',
        margin: 'auto',
        maxWidth: 868,
        maxHeight: 1057,
      },
    },
    modalContent: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      alignItems: 'stretch',
      [children('> *:not(:last-child)')]: {
        marginBottom: 20,
      },
      [media.tablet]: {
        [children('> *:not(:last-child)')]: {
          marginBottom: 27,
        },
      },
      [media.desktop]: {
        [children('> *:not(:last-child)')]: {
          marginBottom: 40,
        },
      },
    },
    title: {
      fontSize: 25,
      lineHeight: 35 / 25,
      textAlign: 'center',
      [media.tablet]: {
        fontSize: 35,
        lineHeight: 45 / 35,
      },
      [media.desktop]: {
        fontSize: 40,
        lineHeight: 50 / 40,
      },
    },
    content: {
      [children('*')]: {
        margin: 0,
      },
      fontSize: 16,
      lineHeight: 20 / 16,
      textAlign: 'center',
      whiteSpace: 'pre-line',
      [media.tablet]: {
        fontSize: 24,
        lineHeight: 28 / 24,
      },
      [media.desktop]: {
        fontSize: 24,
        lineHeight: 28 / 24,
        fontWeight: 'bold',
      },
    },
    buttonsContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '0px 15px',
      [media.smallerThanTablet]: {
        alignItems: 'center',
        [children('> button:not(:last-child)')]: {
          margin: '0 0 20px 0',
        },
      },
      [media.tablet]: {
        flexDirection: 'row-reverse',
        justifyContent: 'center',
        flexWrap: 'nowrap',
        padding: '0px 20px',
        [children('> button')]: {
          ':last-child': {
            margin: '0 25px 0 0',
          },
          ':first-child': {
            margin: '0 0 0 25px',
          },
        },
      },
      [media.desktop]: {
        [children('> button')]: {
          ':last-child': {
            margin: '0 35px 0 0',
          },
          ':first-child': {
            margin: '0 0 0 35px',
          },
        },
      },
    },
    button: {
      border: '1px solid #E60012',
      borderRadius: 5,
      padding: '20px 36px',
      fontSize: 16,
      lineHeight: 20 / 16,
      fontWeight: 'bold',
      [media.smallerThanTablet]: {
        width: '100%',
        maxWidth: 300,
      },
      [media.tablet]: {
        fontSize: 24,
        lineHeight: 29 / 24,
        padding: '16px 32px',
      },
    },
    stayButton: {
      background: 'linear-gradient(180deg, rgba(230,0,18,1) 0%, rgba(152,0,12,1) 100%)',
      border: 'none',
      color: 'white',
      [media.desktop]: {
        background: palette.red,
      },
    },
    leaveButton: {
      background: 'transparent',
      color: palette.red,
    },
  });
};
